<template>
  <div style="width: 90%;margin: auto;padding: 10px;">
    <div style="margin-left: -35px;">
      <el-form ref="form" :inline="true" :model="form" label-width="80px">
        <el-form-item label="门店">
          <el-select filterable v-model="form.storeId" placeholder="请选择门店">
            <el-option
                v-for="item in optionStore"
                :key="item.shopId"
                :label="item.shopName"
                :value="item.shopId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: 10px;" type="primary" @click="search">查询</el-button>
          <el-button type="reset" @click="reset">重置</el-button>
          <el-button type="warning" @click="back">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="width: 100%;margin: auto;padding: 10px 0px;color: red;">
      预警周期：{{ startDate }} - {{ endDate }}
    </div>
    <div style="width: 100%;margin: auto;padding: 10px 0px;color: red;margin-bottom: 50px;">
      规则说明：按品牌所属的小品类标准租售比，高于租售比X的作为预警品牌。
    </div>
    <div style="margin: 30px auto;text-align: left;width: 100%;">
      <el-row>
        <el-col :span="6" class="tl">
          <div>预警品牌数</div>
          <div>{{ emptyshopCount }}</div>
        </el-col>
      </el-row>
    </div>

    <div style="margin-top: 30px;" v-if="role != 1 || searchIn == 1">
      <p><span class="text-gradient1" style="font-size: 20px;margin-right: 20px;margin-bottom: 100px;">收缴率清单</span> </p>
      <el-table
          :data="tableDataC"
          style="width: 100%">
        <el-table-column
            label="门店"
			prop="storeName"
            width="180">
        </el-table-column>
        <el-table-column
            prop="gzName"
            label="柜组"
            width="180">
        </el-table-column>
        <el-table-column
            label="厅房">
          <template slot-scope="scope">
            <span>【{{ scope.row.deptId }}】【{{ scope.row.deptName }}】</span>
          </template>
        </el-table-column>
		<el-table-column
		    prop="rentSaleRat"
		    label="租售比">
		</el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import StoreApi from "../../api/pd/common/StoreApi";
import AlarmOrderApi from "../../api/alarm/order/AlarmOrderApi";
import { default as commonIn } from '@/util/common'
export default {
  name: "collectionRateDetail",
  props: {
    item: {
      type: Object,
      default: null
    },
    storeId: {
      type: String,
      default: ""
    },
    role: {
      type: Number
    },
    turnType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tableData: [

      ],
      tableDataC: [

      ],
      form: {
        storeId: ''
      },
      optionStore: [],
      searchIn: 0,
      emptyshopCount: 0,
      startDate: '',
      endDate: ''
    }
  },
  mounted() {
    let that = this
    console.log(this.item)
    let dateIn = commonIn.timeFormatSeconds(this.item.createDate)
    let dateArr = commonIn.getAlarmCycle({date: dateIn, type: this.item.taskType})
    this.startDate = dateArr[0]
    this.endDate = dateArr[1]

    this.getStore()
    this.onInit().then(async function (){
      await that.getUserInfo()
    }).then(function () {
      let params = {
        storeId: that.storeId, createDate: dateIn, role: that.role,
        taskType: that.item.taskType, positionDeptId: that.item.positionDeptId, userId: that.item.userId
      }
      if (that.item.taskType == 2) {
        params.createDate = commonIn.timeFormatSeconds(that.item.createDate)
      }

      if (that.role == 1) {
        that.storeId = ""
        params.storeId = ''
      }
      if (that.role == 2 && that.item.taskType == 2) {
		params.storeId = that.item.deptCode
      }
      if (that.storeId != null && that.storeId != undefined && that.storeId != '') {
        that.form.storeId = '60' + that.storeId
        console.log(that.role)
      }
      that.getRentSaleRateDetail(params)
    })

  },
  methods: {
    onInit() {
      return Promise.resolve()
    },
    // 获取用户信息
    async getUserInfo() {
      let that = this
      await AlarmOrderApi.getUserInfo({userId: this.item.userId}).then(res => {
        console.log(res);
        res = res.data
        if (res.code == 200) {
          let userInfo = res.data
          if (userInfo.id != undefined && userInfo.id != null) {
            if (userInfo.id == 1 || userInfo.id == 2 || userInfo.id == 5 || userInfo.id == 7) {
              that.role = 2
            } else if (userInfo.id == 6) {
              that.role = 1
            } else if (userInfo.id == 3 || userInfo.id == 4) {
              that.role = 3
            }
          }
          console.log(that.role)
        }
      })
    },
    // 获取门店列表
    getStore() {
      let that = this
      StoreApi.queryStoreList().then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.optionStore = res.data.shopPriviledges
          console.log(that.optionStore)
        } else {
          that.$message.error(res.msg)
        }
      }).catch(error => {
        console.log(error)
        that.$message.warning('系统错误！请稍后尝试')
      })
    },
    // 获取门店空铺详情
    getRentSaleRateDetail(params) {
      let that = this

      AlarmOrderApi.getRentSaleRateDetail(params).then(res => {
        console.log(res.data)
        res = res.data
        if (res.code == 200) {
          that.tableDataC =  res.data
          that.emptyshopCount = that.tableDataC.length
        }
      })
    },
    search() {
      let shopId = this.form.storeId
      shopId = shopId >= 6000 ? shopId.slice(-2) : shopId
      let shopIdIn = shopId.length == 1 ? '0' + shopId : shopId
      let createDate = commonIn.timeFormatSeconds(this.item.createDate)
      let params = {
        storeId: shopIdIn,
        createDate: createDate,
        role: this.role,
        taskType: this.item.taskType,
        positionDeptId: this.item.positionDeptId,
        userId: this.item.userId
      }
      if (this.item.taskType == 2) {
        params.createDate = ''
      }
      this.searchIn = 1
      this.getRentSaleRateDetail(params)
    },
    reset() {
      this.form.resetFields()
    },
    // 返回
    back() {
      console.log(this.turnType)
      if (this.turnType == 1) {
        this.$emit("addCallbackTask")
      } else {
        this.$emit("back")
      }
    }
  }
}
</script>

<style scoped>
.tc {
  text-align: center;
}
.tl {
  text-align: left;
}
.tr {
  text-align: right;
}
.text-gradient1 {
  background-image: linear-gradient(to right, #ffd666, #ad6800);
  -webkit-background-clip: text;
  color: transparent;
}
</style>